// Exposes node require
export default eval('typeof require !== \'undefined\' && require'); // eslint-disable-line no-eval



// WEBPACK FOOTER //
// ./runtime/electron/require.js